'use es6';
/*
 * Adds code commenting commands to the CodeMirror editor.
 *
 * Toggles comment for entire lines.
 *   Cmd-/
 *   Ctrl-/
 * Adds block comment around selection.
 *   Cmd-Alt-/
 *   Ctrl-Shift-/
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import getComponentName from 'react-utils/getComponentName';
import { posSorter } from 'react-codemirror/util/Sort';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/comment/continuecomment';
export default function comment() {
  return function withComment(CodemirrorComponent) {
    /**
     * @class
     */
    class WithComment extends Component {
      constructor(props) {
        super(props);
        /** @type {Object} CodeMirror instance taken from ref */

        this.codemirror = null;
        this.refCodemirror = this.refCodemirror.bind(this);
        this.blockComment = this.blockComment.bind(this);
      }

      componentDidUpdate(prevProps) {
        if (prevProps.enableCommentKeys !== this.props.enableCommentKeys) {
          this.updateKeyMap();
        }
      }

      codemirrorDidMountOrUpdate(codemirror) {
        if (this.codemirror === codemirror) {
          return;
        }

        this.codemirror = codemirror;

        if (!this.codemirror) {
          return;
        }

        this.updateKeyMap();
      }

      get keyMap() {
        if (this.__keyMap) {
          return this.__keyMap;
        }

        return this.__keyMap = {
          // Toggles comment for entire lines.
          'Cmd-/': 'toggleComment',
          'Ctrl-/': 'toggleComment',
          // Adds block comment around selection.
          'Cmd-Alt-/': this.blockComment,
          'Ctrl-Shift-/': this.blockComment
        };
      }

      updateKeyMap() {
        if (!this.codemirror) {
          return;
        }

        const method = this.props.enableCommentKeys ? 'addKeyMap' : 'removeKeyMap';
        this.codemirror[method](this.keyMap);
      }
      /*
       * Events
       */


      blockComment() {
        if (!this.codemirror) {
          return;
        }

        const {
          sel: selections
        } = this.codemirror.doc;
        const options = {
          fullLines: false
        };
        selections.ranges.forEach(({
          anchor,
          head
        }) => {
          const [from, to] = [anchor, head].sort(posSorter);
          this.codemirror.blockComment(from, to, options);
        });
      }
      /*
       * Render
       */


      refCodemirror(ref) {
        const codemirror = ref && ref.codemirror;
        this.codemirrorDidMountOrUpdate(codemirror);

        if (this.props.refCodemirror) {
          this.props.refCodemirror(ref);
        }
      }

      render() {
        return /*#__PURE__*/_jsx(CodemirrorComponent, Object.assign({}, this.props, {
          refCodemirror: this.refCodemirror
        }));
      }

    }
    /*
     * Statics
     */


    WithComment.propTypes = {
      refCodemirror: PropTypes.func,
      enableCommentKeys: PropTypes.bool
    };
    WithComment.defaultProps = {
      enableCommentKeys: true
    };
    WithComment.displayName = `WithComment(${getComponentName(CodemirrorComponent)})`;
    return WithComment;
  };
}